import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  notifications: [],
  unreadCount: 0,
  totalCount: 0,
  loading: false,
  error: null,
  showDropdown: false,
};

const notificationSlice = createSlice({
  name: 'notifications',
  initialState,
  reducers: {
    fetchNotificationsRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchNotificationsSuccess: (state, action) => {
      state.loading = false;
      state.notifications = action.payload.data || [];
      state.error = null;
    },
    fetchNotificationsFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    fetchNotificationCountRequest: (state) => {
      // Don't set loading for count to avoid blocking UI
    },
    fetchNotificationCountSuccess: (state, action) => {
      state.unreadCount = action.payload.unreadCount || 0;
      state.totalCount = action.payload.totalCount || 0;
    },
    fetchNotificationCountFailure: (state, action) => {
      state.error = action.payload;
    },
    markAsReadRequest: (state, action) => {
      // Don't update optimistically - wait for server response to ensure persistence
      // The UI will be updated when fetchNotificationsSuccess is called
    },
    markAsReadSuccess: (state, action) => {
      // Update will come from fetchNotificationsSuccess after refresh
    },
    markAsReadFailure: (state, action) => {
      state.error = action.payload;
      // Revert optimistic update if needed
    },
    markAllAsReadRequest: (state) => {
      // Don't update optimistically - wait for server response to ensure persistence
      // The UI will be updated when fetchNotificationsSuccess is called
    },
    markAllAsReadSuccess: (state) => {
      // Update will come from fetchNotificationsSuccess after refresh
    },
    markAllAsReadFailure: (state, action) => {
      state.error = action.payload;
    },
    deleteNotificationRequest: (state, action) => {
      // Find notification before removing to check if it was unread
      const deletedNotification = state.notifications.find(n => n.id === action.payload);
      const wasUnread = deletedNotification && !deletedNotification.isRead;
      
      // Optimistically remove notification
      state.notifications = state.notifications.filter(n => n.id !== action.payload);
      
      if (state.totalCount > 0) {
        state.totalCount -= 1;
      }
      
      // Decrease unread count if deleted notification was unread
      if (wasUnread && state.unreadCount > 0) {
        state.unreadCount -= 1;
      }
    },
    deleteNotificationSuccess: (state) => {
      // Already updated optimistically
    },
    deleteNotificationFailure: (state, action) => {
      state.error = action.payload;
      // Note: We don't revert here as we'd need to refetch
    },
    toggleDropdown: (state) => {
      state.showDropdown = !state.showDropdown;
    },
    closeDropdown: (state) => {
      state.showDropdown = false;
    },
  },
});

export const {
  fetchNotificationsRequest,
  fetchNotificationsSuccess,
  fetchNotificationsFailure,
  fetchNotificationCountRequest,
  fetchNotificationCountSuccess,
  fetchNotificationCountFailure,
  markAsReadRequest,
  markAsReadSuccess,
  markAsReadFailure,
  markAllAsReadRequest,
  markAllAsReadSuccess,
  markAllAsReadFailure,
  deleteNotificationRequest,
  deleteNotificationSuccess,
  deleteNotificationFailure,
  toggleDropdown,
  closeDropdown,
} = notificationSlice.actions;

export default notificationSlice.reducer;

